/** Product name shown in shell UI (login, header). */
export const APP_DISPLAY_NAME = 'LEDGER';

/** Shorter label where space is tight. */
export const APP_SHORT_NAME = 'Ledger';
